import { render } from "./AffiliateLogs.vue?vue&type=template&id=6cf664d4&ts=true"
import script from "./AffiliateLogs.vue?vue&type=script&lang=ts"
export * from "./AffiliateLogs.vue?vue&type=script&lang=ts"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
